import React from "react";
import { PLATFORMS } from "./PlatformDefinitions";
import { fmtDate, getPlatformStatus, PLATFORM_DISPLAY, statusLabel, statusTone } from "../lib/platformStatus";

const TONE_DOT = { green: "bg-emerald-400", yellow: "bg-amber-400", red: "bg-red-500" };

export default function PlatformMatrixOverview({ video }) {
  return (
    <div className="space-y-3" data-testid="platform-matrix-overview">
      <div className="border-b border-zinc-800 pb-3">
        <h3 className="text-base font-semibold text-white">Comprehensive Platform Matrix</h3>
        <p className="mt-1 text-xs text-zinc-500">Live publication overview</p>
      </div>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 xl:grid-cols-3">
        {PLATFORMS.map((platform) => {
          const display = PLATFORM_DISPLAY.find((entry) => entry.key === platform.id) || { key: platform.id, label: platform.label };
          const row = getPlatformStatus(video, display);
          const tone = statusTone(row.status);
          const status = platform.statuses.find((option) => option.value === row.status)?.label || statusLabel(row.status) || "Not published";

          return (
            <article key={platform.id} data-testid={`matrix-platform-${platform.id}`} className="min-w-0 rounded-lg border border-zinc-800 bg-black/30 p-3">
              <div className="flex min-w-0 items-center gap-2">
                <span aria-hidden="true" className="text-base">{platform.emoji}</span>
                <span className="truncate text-sm font-medium text-zinc-200">{row.label || platform.label}</span>
                <span className={`ml-auto h-2 w-2 shrink-0 rounded-full ${TONE_DOT[tone]}`} aria-label={status} title={status} />
              </div>
              <div className="mt-2 flex items-start justify-between gap-3 text-xs">
                <span className="min-w-0 truncate text-zinc-300" title={status}>{status}</span>
                {platform.hasPrice && row.price !== null && row.price !== undefined && row.price !== "" && (
                  <span className="shrink-0 text-zinc-400">${row.price}</span>
                )}
              </div>
              {row.posted_date && <p className="mt-1 text-[11px] text-zinc-500">Posted {fmtDate(row.posted_date)}</p>}
              {row.notes && <p className="mt-1 line-clamp-2 break-words text-[11px] text-zinc-500" title={row.notes}>{row.notes}</p>}
            </article>
          );
        })}
      </div>
    </div>
  );
}